import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import Homepage from "./components/Homepage";
import AboutMe from "./components/AboutMe";
import theme from "./theme";
import GlobalStyle from "./GlobalStyle";
import Programm from './components/Programm';
import FAQ from './components/FAQ';
import MyPage from './components/MyPage';
import { AuthProvider } from './AuthContext';
import AGB from './components/AGB';
import LessonPackagePurchasePage from './components/LessonPackagePurchasePage';
import TrialLessonPurchasePage from './components/TrialLessonPurchasePage';
import TrialLessonSuccessPage from './components/TrialLessonSuccessPage';
import TrialLessonCancelPage from './components/TrialLessonCancelPage';
import PurchaseSuccessPage from './components/PurchaseSuccessPage';
import PurchasedPackagesPage from './components/PurchasedPackagesPage';
import PastLessonsPage from './components/PastLessonsPage';
import ManageLessonPage from './components/ManageLessonPage';
import MeysPage from './components/MeysPage';
import AllUsersPage from './components/AllUsersPage';
import ProtectedRoute from './components/ProtectedRoute';
import LandscapeModeMessage from './components/LandscapeModeMessage';
import AboutProject from './components/AboutProject';

function App() {
  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <LandscapeModeMessage />
        <Router>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/academy" element={<Homepage />} />
            <Route path="/about" element={<AboutMe />} />
            <Route path="/about-me" element={<AboutMe />} />
            <Route path="/program" element={<Programm />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contacts" element={<div>Contacts Page</div>} />
            <Route path="/privacy" element={<div>Privacy Policy</div>} />
            <Route path="/mypage" element={<ProtectedRoute><MyPage /></ProtectedRoute>} />
            <Route path="/buy" element={<ProtectedRoute><LessonPackagePurchasePage /></ProtectedRoute>} />
            <Route path="/trial-lesson-purchase" element={<TrialLessonPurchasePage />} />
            <Route path="/trial-lesson-success" element={<TrialLessonSuccessPage />} />
            <Route path="/trial-lesson-cancel" element={<TrialLessonCancelPage />} />
            <Route path="/purchase-success" element={<PurchaseSuccessPage />} />
            <Route path="/purchased-packages" element={<ProtectedRoute><PurchasedPackagesPage /></ProtectedRoute>} />
            <Route path="/past-lessons" element={<ProtectedRoute><PastLessonsPage /></ProtectedRoute>} />
            <Route path="/manage-lesson/:lessonId" element={<ProtectedRoute><ManageLessonPage /></ProtectedRoute>} />
            <Route path="/meys-page" element={<ProtectedRoute><MeysPage /></ProtectedRoute>} />
            <Route path="/all-users" element={<ProtectedRoute><AllUsersPage /></ProtectedRoute>} />
            <Route path="/terms" element={<AGB />} />
            <Route path="/about-project" element={<AboutProject />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
